






























import Vue from 'vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'HomeMeetOurTeam',
  components: {
    Block,
  },
  data: () => ({}),
})
